import { render } from "./PaymentOption.vue?vue&type=template&id=1227b484&scoped=true"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"

import "./PaymentOption.vue?vue&type=style&index=0&id=1227b484&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1227b484"]])

export default __exports__